export type CustomerDetails = {
  name: string;
  email: string;
  phone: string;
  message: string;
};

export enum PaymentOption {
  Full = "full",
  Deposit = "deposit",
}
